const FormatPrice = ({ dollars, cents = "" }) => {
  const s = dollars[0];
  const d = dollars.slice(1);
  return (
    <div className="dollarsCents" data-price={`${s} ${d}.${cents}`}>
      <span className="sign">{s}</span>
      <span className="dollars">{d}</span>
      {cents ? <span className="cents">.{cents}</span> : ""}
    </div>
  );
};

export default FormatPrice;
